import { api } from '@/lib/pos-api';

// All rows are an explicit user action, not the default cost of opening a page.
export async function fetchAllHistory(params, { signal, onProgress } = {}) {
  const matching = new Map();
  let total = null;
  for (let offset = 0; ; offset += 300) {
    const { data } = await api.get('/transactions/history', { signal, params: { ...params, limit: 300, offset, include_total: offset === 0 } });
    if (signal?.aborted) return [];
    data.items.forEach(row => matching.set(row.id, row));
    if (data.total != null) total = data.total;
    onProgress?.([...matching.values()], data.total);
    if (data.items.length < 300 || (total != null && offset + data.items.length >= total)) break;
  }
  return [...matching.values()];
}
